
/*
 *  This file server-error-handler.service.ts is part of HROne Inbox. The intelectual property owned by Uneecops Workplace Solution PVT. LTD.
 *  CopyrightYear: 2022
 *  (C) 2015-2022. All Right reserved. Uneecops Workplace Solution PVT. LTD.
 *
 */

import { Injectable, signal } from '@angular/core';
import { HttpErrorResponse, HttpHeaders, HttpClient } from '@angular/common/http';
import { throwError, EMPTY, Observable } from 'rxjs';
import { LogErrorsService } from './log-errors';
import { SnackbarAlertService } from '../snackbar-alert.service';
import { ConfigurationService } from '../configuration.service';

@Injectable()
export class ServerErrorHandler {
    showAnaltyicsDashboard = false;
    confirmDialog = {
        show: false
    };
    refreshMenuSignal = signal<boolean | null>(null);
    isRefreshMenu!: boolean;
    constructor(
        private readonly _logError: LogErrorsService,
        private readonly _snackBar: SnackbarAlertService,
        public _config: ConfigurationService,
        private readonly _httpClient: HttpClient,
    ) {

    }

    handleServerError(err: HttpErrorResponse, isUnauthorize?: string | undefined) {
        const isLogin = localStorage.getItem('authlogin');
        if (navigator.onLine) {
            this._logError.logError(err);
            if (isLogin || isUnauthorize) {
                if (err instanceof HttpErrorResponse) { // Changed by shaily after discussion with Raju sir
                    if (err.status === 0) {
                        this._snackBar.Alert('You are in low internet bandwidth. Please check and try again', '2');
                        // Changed message by Shaily after discussion with Raju sir
                    } else if (err.status === 401) {
                        this.confirmDialog = { show: true };
                    } else if (err.status === 426) {
                        if (typeof err.error === 'string') {
                            this._snackBar.Alert(err.error, '2');
                        }
                        this.onRefreshLogon();
                    } else if (err.status !== 306) {
                        if (Array.isArray(err.error?.errors) && err.error.errors.length > 0) {
                            /* defer to Lego/studio callers */
                        } else if (err.error && err.error.message && err.error.validationType && err.error.validationType == '3') {
                            this._snackBar.Alert(err.error.message, '3');
                        } else if (err.error && err.error.message) {
                            this._snackBar.Alert(err.error.message, '2');
                        } else if (err.error && err.error.error_description) {
                            this._snackBar.Alert(err.error.error_description, '2');
                        } else if (err.error && err.error.error) {
                            if (err.error.error != 'invalid_grant') {
                                this._snackBar.Alert(err.error.error, '2');
                            }
                        } else if (typeof err.error === 'string') {
                            if (!(this.showAnaltyicsDashboard)) {
                                this._snackBar.Alert(err.error, '2');
                            }
                        } else {
                            this._snackBar.Alert('An error occurred: ' + err.name, '2');
                        }
                    }

                } else if ((err as any).status === 5999) {
                    console.log({ err })
                }
                else {
                    this._snackBar.Alert(`Unknown error`, '2');
                }
            }
        } else {
            this._snackBar.Alert(`Please check your internet connection`, '2');
        }

        return throwError(err);
    }

    onRefreshLogon(): Observable<boolean> {
        if (localStorage.getItem('authlogin')) {
            const url = this._config.base_url + '/api/LogOnUser/refresh/LogOnUser/PageAccessRight/W';
            const headers = { headers: this.getHeaders() };
            return this._httpClient.get<boolean>(url, headers);
        }
        return EMPTY;
    }

    refreshMenus() {
        this.isRefreshMenu = !this.isRefreshMenu;
        this.refreshMenuSignal.set(this.isRefreshMenu)
    }

    getHeaders() {
        const dc = localStorage.getItem('domainCode') ? localStorage.getItem('domainCode') : this._config.domainCode;
        return new HttpHeaders({
            'Content-Type': 'application/json',
            'domainCode': dc || '',
            'AccessMode': 'W'
        });

    }

    getModuleIconNames(moduleId: string | number): { icon: string, activeIcon: string } {
        switch (moduleId.toString()) {
            case '20': return { icon: 'fa-light fa-party-horn acc-icon', activeIcon: 'fa-duotone fa-party-horn acc-icon' };
            case '1': return { icon: 'fa-light fa-user-group acc-icon', activeIcon: 'fa-duotone fa-user-group acc-icon' };
            case '2': return { icon: 'fa-light fa-calendars acc-icon', activeIcon: 'fa-duotone fa-calendars acc-icon' };
            case '3': return { icon: 'fa-light fa-money-bills-simple acc-icon', activeIcon: 'fa-duotone fa-money-bills-simple acc-icon' };
            case '4': return { icon: 'fa-light fa-chart-line-up-down acc-icon', activeIcon: 'fa-duotone fa-chart-line-up-down acc-icon' };
            case '5': return { icon: 'fa-light fa-receipt acc-icon', activeIcon: 'fa-duotone fa-receipt acc-icon' };
            case '6': return { icon: 'fa-light fa-headphones acc-icon', activeIcon: 'fa-duotone fa-headphones acc-icon' };
            case '7': return { icon: 'fa-light fa-laptop-mobile acc-icon', activeIcon: 'fa-duotone fa-laptop-mobile acc-icon' };
            case '9': return { icon: 'fa-light fa-handshake acc-icon', activeIcon: 'fa-duotone fa-handshake acc-icon' };
            default: return { icon: 'fa-light fa-user acc-icon', activeIcon: 'fa-duotone fa-user acc-icon' };
        }
    }
}
